import { getEncodedParams } from 'helpers/encodeParams';

exports.youtubeCampaignSummaryEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/youtube/campaign/summary?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.youtubeAdgroupSummaryEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/youtube/adgroup/summary?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.youtubeCreativeSummaryEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/youtube/creative/summary?start=${encodedParams.start}&end=${encodedParams.end}`;
};



// WEBPACK FOOTER //
// ./src/services/youtube/selectors.js